<template>
  <div class="personal-notification__boxes">
    <PersonalNotificationBox
      v-for="personalNotification in personalNotifications"
      :key="personalNotification.id"
      :personal-notification-id="personalNotification.id"
      :message="personalNotification.message"
      :started-at="personalNotification.startedAt"
      :icon-url="personalNotification.iconUrl"
      :icon-style="personalNotification.iconStyle"
      :link-url="personalNotification.linkUrl"
      :unread="personalNotification.unread"
      @click-delete-button="onClickDeleteButton"
      @click-link="onClickLink"
    />
  </div>
</template>
<script>
import PersonalNotificationBox from './PersonalNotificationBox.vue'
export default {
  components: { PersonalNotificationBox },
  props: {
    personalNotifications: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickDeleteButton(personalNotificationId) {
      this.$emit(
        'click-personal-notification-delete-button',
        personalNotificationId
      )
    },
    onClickLink(personalNotificationId) {
      this.$emit('click-personal-notification-link', personalNotificationId)
    }
  }
}
</script>
<style lang="scss" scoped>
.personal-notification {
  &__boxes {
    margin: auto;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
